<template>
  <v-content id="listing">
    <section>
      <v-container>
        <div class="headline text-xs-center">Download the Leaply app for your platform</div>
        <div class="title text-xs-center">
          and then
          <a :href="`//leap.ly/listings/${$route.params.id}`" class="purple--text text--accent-4">click here</a>
          or scan the QR code again to open the listing.
        </div>
        <v-layout align-center justify-center row wrap>
          <v-flex xs-12 md-4 class="pa-2">
            <v-card class="mb-4" hover href="https://apps.apple.com/za/app/leaply/id1663785025">
              <v-img src="/img/listings_app_store.svg" alt="Download from the App Store" />
              <v-card-title class="title text-xs-center">Get it on the App Store</v-card-title>
            </v-card>
          </v-flex>
          <v-flex xs-12 md-4 class="pa-2">
            <v-card class="mb-4" hover href="https://play.google.com/store/apps/details?id=ly.leap.mobile.leaply">
              <v-img src="/img/listings_play_store.svg" alt="Download from the Play Store" />
              <v-card-title class="title text-xs-center">Get it on the Play Store</v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </v-content>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'

// Components

// Vue Component
export default {
  computed: mapGetters({ role: 'auth/role' }),
}
</script>

<style>
mainlisting {
  padding-top: 0 !important;
}
</style>
